import {
  //CREATE
  CREATE_ENQUIRY_FAILED,
  CREATE_ENQUIRY_SUCCESS,
  CREATE_ENQUIRY_START,
  ////////////

  //DELETE
  DELETE_ENQUIRY_FAILED,
  DELETE_ENQUIRY_SUCCESS,
  DELETE_ENQUIRY_START,
  ////////////

  //UPDATE
  UPDATE_ENQUIRY_FAILED,
  UPDATE_ENQUIRY_SUCCESS,
  UPDATE_ENQUIRY_START,
  UPDATE_PULLFORWARD_ENQUIRY_SUCCESS,
  CLEAR_PULLFORWARD_ENQUIRY_SUCCESS,
  ////////////

  //UNARCHIVE ENQUIRY
  UNARCHIVE_ENQUIRY_START,
  UNARCHIVE_ENQUIRY_SUCCESS,

  //ARCHIVE ENQUIRY
  ARCHIVE_ENQUIRY_START,
  ARCHIVE_ENQUIRY_SUCCESS,
  ARCHIVE_ENQUIRY_FAILED,

  //ERROR MANAGEMENT
  CLEAR_ENQUIRY_ERROR,
  ENQUIRY_ERROR,
  ////////////

  ///FETCH
  FETCH_ENQUIRY_START,
  FETCH_ENQUIRY_SUCCESS,
  FETCH_ENQUIRY_FAILED,
  //////
  FETCH_ENQUIRIES_START,
  FETCH_ENQUIRIES_SUCCESS,
  FETCH_ENQUIRIES_FAILED,

  //UNREAD ENQUIRY
  MARK_ENQUIRY_UNREAD_START,
  MARK_ENQUIRY_UNREAD_SUCCESS,
  MARK_ENQUIRY_UNREAD_FAILED,

  //TIMELINE
  FETCH_TIMELINE_START,
  FETCH_TIMELINE_SUCCUSS,
  FETCH_TIMELINE_FAILED,
  /////////

  //FETCH BRANCH ENQUIRIES
  FETCH_BRANCH_ENQUIRIES_START,
  FETCH_BRANCH_ENQUIRIES_SUCCESS,
  FETCH_BRANCH_ENQUIRIES_FAILED,
  /////////

  //CALLLIST
  ADD_ENQUIRY_TO_CALLLIST_START,
  ADD_ENQUIRY_TO_CALLLIST_SUCCUSS,
  REMOVE_ENQUIRY_FROM_CALLLIST_START,
  REMOVE_ENQUIRY_FROM_CALLLIST_SUCCESS,

  //WHITEBOARD
  ADD_ENQUIRY_TO_WHITEBOARD_START,
  ADD_ENQUIRY_TO_WHITEBOARD_SUCCESS,
  REMOVE_ENQUIRY_FROM_WHITEBOARD_START,
  REMOVE_ENQUIRY_FROM_WHITEBOARD_SUCCESS,

  //INVESTOR
  ADD_ENQUIRY_TO_INVESTOR_START,
  ADD_ENQUIRY_TO_INVESTOR_SUCCESS,
  REMOVE_ENQUIRY_FROM_INVESTOR_START,
  REMOVE_ENQUIRY_FROM_INVESTOR_SUCCESS,

  //VIEW ENQUIRY
  VIEW_ENQUIRY_START,
  VIEW_ENQUIRY_SUCCESS,
  VIEW_ENQUIRY_FAILED,
} from "../store/types";

const INITIAL_STATE = {
  enquiries: [],

  branchEnquirries: [],
  activeBranchEnquiries: [],
  inactiveBranchEnquiries: [],

  currentEnqury: null,
  completed: false,
  loading: false,
  success: false,
  pullforward: {
    flag: false,
    msg: null,
  },
  error: {
    flag: false,
    msg: null,
  },

  timeline: {
    //Fetch
    fetch: {
      loading: false,
      currentTimeLine: [],
      completed: false,
      success: false,
    },

    //Add
    add: {
      loading: false,
      completed: false,
      success: false,
    },
  },
};

let currentEnqury;
let currentEnquiries;
let activeBranchEnquiries;
let index;

export const enquiryreducer = (state = INITIAL_STATE, action) => {
  console.log("action", action.type);
  switch (action.type) {
    case FETCH_ENQUIRIES_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ENQUIRIES_SUCCESS:
      return {
        ...state,
        loading: false,
        enquiries: action.payload,
      };
    case FETCH_ENQUIRIES_FAILED:
      return {
        ...state,
        loading: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    case FETCH_BRANCH_ENQUIRIES_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_BRANCH_ENQUIRIES_SUCCESS:
      return {
        ...state,
        branchEnquirries: action.payload,
        activeBranchEnquiries: action.payload.activeEnquiries,
        inactiveBranchEnquiries: action.payload.inactiveEnquiries,
        loading: false,
      };
    case FETCH_BRANCH_ENQUIRIES_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    case FETCH_ENQUIRY_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        currentEnqury: action.payload,
      };

    case FETCH_ENQUIRY_FAILED:
      return {
        ...state,
        currentEnqury: null,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    case DELETE_ENQUIRY_START:
      return {
        ...state,
        loading: true,
      };
    case DELETE_ENQUIRY_SUCCESS:
      let deleteArr = state.enquiries;
      let newArr = [];
      deleteArr.map((enquiry) => {
        if (enquiry.id !== action.payload) {
          newArr.push(enquiries);
        }
      });
      return {
        ...state,
        enquiries: newArr,
        loading: false,
      };

    case CLEAR_ENQUIRY_ERROR:
      return {
        ...state,
        completed: false,
        loading: false,
        success: false,
        error: {
          flag: false,
          msg: null,
        },
      };

    case CLEAR_PULLFORWARD_ENQUIRY_SUCCESS:
      return {
        ...state,
        completed: false,
        loading: false,
        success: false,
        pullforward: {
          falg: false,
          msg: null,
        },
        error: {
          flag: false,
          msg: null,
        },
      };

    case ENQUIRY_ERROR:
      return {
        ...state,
        loading: false,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };

    //?FETCH TIMELINE
    case FETCH_TIMELINE_START:
      return {
        ...state,
        timeline: {
          ...state.timeline,
          fetch: {
            ...state.timeline.fetch,
            loading: true,
            completed: false,
            currentTimeLine: [],
          },
        },
      };

    case FETCH_TIMELINE_SUCCUSS:
      return {
        ...state,
        timeline: {
          ...state.timeline,
          fetch: {
            ...state.timeline.fetch,
            loading: false,
            completed: true,
            success: true,
            currentTimeLine: action.payload,
          },
        },
      };

    case FETCH_TIMELINE_FAILED:
      return {
        ...state,
        timeline: {
          ...state.timeline,
          fetch: {
            ...state.timeline.fetch,
            loading: false,
            completed: true,
            success: false,
            currentTimeLine: [],
          },
        },
      };
    ///////////////////////////////////////

    //?CREATE ENQUIRY

    case CREATE_ENQUIRY_START:
      return {
        ...state,
        loading: true,
        completed: false,
        currentEnqury: null,
      };

    case CREATE_ENQUIRY_SUCCESS:
      return {
        ...state,
        loading: false,
        completed: true,
        success: true,
        currentEnqury: action.payload,
        enquiries: [...state.enquiries, action.payload],
        activeBranchEnquiries: [...state.activeBranchEnquiries, action.payload],
      };

    case CREATE_ENQUIRY_FAILED:
      return {
        ...state,
        currentEnqury: null,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    /////////////////////////

    //?ADD TO CALL LIST
    case ADD_ENQUIRY_TO_CALLLIST_START:
      return {
        ...state,
        loading: true,
      };

    case ADD_ENQUIRY_TO_CALLLIST_SUCCUSS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //?ADD TO WHITEBOARD
    case ADD_ENQUIRY_TO_WHITEBOARD_START:
      return {
        ...state,
        loading: true,
      };

    case ADD_ENQUIRY_TO_WHITEBOARD_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //?ADD TO WHITEBOARD
    case ADD_ENQUIRY_TO_INVESTOR_START:
      return {
        ...state,
        loading: true,
      };

    case ADD_ENQUIRY_TO_INVESTOR_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //??ARCHIVE FOR ME
    case ARCHIVE_ENQUIRY_START:
      return {
        ...state,
        loading: true,
      };

    case ARCHIVE_ENQUIRY_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //??UNARCHIVE FOR ME
    case UNARCHIVE_ENQUIRY_START:
      return {
        ...state,
        loading: true,
      };

    case UNARCHIVE_ENQUIRY_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //??UN VEIW ENQUIRY
    case MARK_ENQUIRY_UNREAD_START:
      return {
        ...state,
        loading: true,
      };

    case MARK_ENQUIRY_UNREAD_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //?REMOVE FROM CALL lIST
    case REMOVE_ENQUIRY_FROM_CALLLIST_START:
      return {
        ...state,
        loading: true,
      };

    case REMOVE_ENQUIRY_FROM_CALLLIST_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //?REMOVE FROM WHITEBOARD
    case REMOVE_ENQUIRY_FROM_WHITEBOARD_START:
      return {
        ...state,
        loading: true,
      };

    case REMOVE_ENQUIRY_FROM_WHITEBOARD_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //?REMOVE FROM INVESTOR
    case REMOVE_ENQUIRY_FROM_INVESTOR_START:
      return {
        ...state,
        loading: true,
      };

    case REMOVE_ENQUIRY_FROM_INVESTOR_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
      }

    //?VIEW ENUIRY

    case VIEW_ENQUIRY_START:
      return {
        ...state,
        loading: true,
      };

    case VIEW_ENQUIRY_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);

      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
        };
        index = null;
      } else {
        return {
          ...state,
          loading: false,
        };
      }

    //?UPDATE ENQUIRY
    case UPDATE_ENQUIRY_START:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_ENQUIRY_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);
      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          enquiries: currentEnquiries,
          loading: false,
          completed: true,
          success: true,
        };
      } else {
        return {
          ...state,
          loading: false,
        };
      }
    case UPDATE_PULLFORWARD_ENQUIRY_SUCCESS:
      currentEnqury = action.payload;
      currentEnquiries = state.enquiries;

      index = currentEnquiries.findIndex((x) => x.id === currentEnqury.id);
      if (index !== -1) {
        currentEnquiries[index] = currentEnqury;

        return {
          ...state,
          loading: false,
          enquiries: currentEnquiries,
          pullforward: {
            flag: true,
            msg: action.msg,
          }
        };
      }
    case UPDATE_ENQUIRY_FAILED:
      return {
        ...state,
        currentEnqury: null,
        loading: false,
        completed: true,
        success: false,
        error: {
          flag: true,
          msg: action.payload,
        },
      };
    //?///////////////////////////

    default:
      return state;
  }
};
